import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=33abb0c1&scoped=true"
import script from "./CheckList.vue?vue&type=script&lang=js"
export * from "./CheckList.vue?vue&type=script&lang=js"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=33abb0c1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33abb0c1",
  null
  
)

export default component.exports